/** Panel-secties van TodayView: overdue, vandaag, next actions, aankomend en afgerond. */
import { useMemo, useState } from 'react';
import { useAuth } from '@/features/auth/useAuth';
import { useTodayViewPanelHints } from '@/features/today/hooks/use-today-view-panel-hints';
import { useTodaySwipeTeaserHint } from '@/features/today/hooks/use-today-swipe-teaser-hint';
import { getCurrentDateAndTime } from '@/utils/timeUtils';
import { TodayCompletedPanel } from './TodayCompletedPanel';
import { readUpcomingUnlocked } from '@/features/today/utils/upcomingUnlock';
import {
  applyUpcomingUnlockIfNeeded,
  getTodayPanelsVisibility,
} from './todayViewPanelsHelpers';
import {
  TodayMainPanelSection,
} from './TodayMainPanelSection';
import {
  TodayNextActionsPanelSection,
} from './TodayNextActionsPanelSection';
import {
  TodayOverduePanelSection,
} from './TodayOverduePanelSection';
import {
  TodayUpcomingPanelSection,
} from './TodayUpcomingPanelSection';

const TodayViewPanels = ({
  t,
  isBattlefield,
  uiContextValue,
  displayOverdueTasks,
  displayTodayTasks,
  displayNextActions,
  displayUpcomingTasks = [],
  todayTasks,
  nextActions,
  completedTodayTasks,
  allTasksCount = 0,
  topActionableTaskId,
  tasksMap,
  selectedTaskIds,
  setSelectedTaskIds,
}) => {
  const todayEmpty = displayTodayTasks.length === 0;
  const [upcomingUnlocked, setUpcomingUnlocked] = useState(readUpcomingUnlocked);
  applyUpcomingUnlockIfNeeded({
    todayEmpty,
    displayUpcomingTasks,
    upcomingUnlocked,
    setUpcomingUnlocked,
  });
  const { showUpcoming, showNextAction, nextActionHintEligible } =
    getTodayPanelsVisibility({
      upcomingUnlocked,
      displayUpcomingTasks,
      nextActions,
      tasksMap,
    });
  const { user } = useAuth();
  const { nextActionHintActive } = useTodayViewPanelHints({
    showNextAction: nextActionHintEligible,
    userId: user?.uid,
    topActionableTaskId,
    t,
  });
  const todayTaskIds = useMemo(
    () => displayTodayTasks.map((task) => task.id),
    [displayTodayTasks],
  );
  const { swipeTeaserTaskId, onSwipeTeaserEnd } = useTodaySwipeTeaserHint({
    isBattlefield,
    todayTaskIds,
    userId: user?.uid,
  });
  const todayDefaultTaskData = { date: getCurrentDateAndTime().date };

  const sectionProps = {
    t,
    isBattlefield,
    uiContextValue,
    displayOverdueTasks,
    displayTodayTasks,
    displayNextActions,
    displayUpcomingTasks,
    todayTasks,
    nextActions,
    completedTodayTasks,
    allTasksCount,
    topActionableTaskId,
    tasksMap,
    selectedTaskIds,
    setSelectedTaskIds,
    todayEmpty,
    showUpcoming,
    showNextAction,
    nextActionHintActive,
    swipeTeaserTaskId,
    onSwipeTeaserEnd,
    todayDefaultTaskData,
  };

  return (
    <>
      <TodayOverduePanelSection {...sectionProps} />
      <TodayMainPanelSection {...sectionProps} />
      <TodayNextActionsPanelSection {...sectionProps} />
      <TodayUpcomingPanelSection {...sectionProps} />
      <TodayCompletedPanel t={t} completedTodayTasks={completedTodayTasks} />
    </>
  );
};

export default TodayViewPanels;
